import { isNotNullOrUndefined } from 'in-time-core';
import { ICloudFunctionsProvider } from './cloud-functions-provider.js';
import { HttpsAuthContext, HttpsCallable } from './https-callable.js';
import { HttpClient } from './https-client.js';

export class FirebaseCloudFunctionsProvider implements ICloudFunctionsProvider {
  private readonly httpClient: HttpClient;
  private readonly projectId: string;
  private readonly appId: string;
  private readonly buildId: number | null;
  private readonly operatingSystem: string;
  private emulatorOrigin: string | null = null;
  private emulatorRegion: string | null = null;

  constructor(args: {
    httpClient: HttpClient,
    projectId: string,
    appId: string,
    buildId: number | null,
    operatingSystem: string,
  }) {
    this.httpClient = args.httpClient;
    this.projectId = args.projectId;
    this.appId = args.appId;
    this.buildId = args.buildId;
    this.operatingSystem = args.operatingSystem;
  }

  getHttpsCallable(functionName: string, context: HttpsAuthContext): HttpsCallable {
    if(isNotNullOrUndefined(this.emulatorOrigin) && isNotNullOrUndefined(this.emulatorRegion)) {
      return new HttpsCallable(
          this.httpClient,
          `${this.emulatorOrigin}/${this.projectId}/${this.emulatorRegion}/${functionName}`,
          context,
          {
            'appId': this.appId,
            'buildId': this.buildId,
            'operatingSystem': this.operatingSystem,
          }
      );
    }
    else {
      return new HttpsCallable(
          this.httpClient,
          `https://${this.getApiGatewayUrl(this.projectId)}/functions/${functionName}`,
          context,
          {
            'appId': this.appId,
            'buildId': this.buildId,
            'operatingSystem': this.operatingSystem,
          }
      );
    }
  }

  useFunctionsEmulator(origin: string, region: string): void {
    this.emulatorOrigin = origin;
    this.emulatorRegion = region;
  }

  private getApiGatewayUrl(projectId: string): string {
    return projectId == 'in-time-fa9b7' ?
      'in-time-api-gateway-9llk7a74.ew.gateway.dev' :
      'in-time-api-gateway-46gavk95.ew.gateway.dev';
  }
}
